// Latest-request-wins tracker: every request takes a ticket when it starts and
// may apply its response only while that ticket is still the newest one.
// `invalidate` makes every in-flight request stale without starting a new one.
export const createLatestRequestTracker = () => {
  let latest = 0;
  let invalidatedThrough = 0;

  return {
    begin: () => {
      latest += 1;
      return latest;
    },
    isLatest: (ticket) => ticket === latest,
    // True when the ticket went stale through `invalidate`, not because a
    // newer request superseded it.
    isInvalidated: (ticket) => ticket <= invalidatedThrough,
    invalidate: () => {
      latest += 1;
      invalidatedThrough = latest;
    },
  };
};
